import React, { useMemo } from "react";

import type { LocationOptionGroup } from "../utils/locationOptions";
import { MobileSelect } from "./ui/MobileSelect";

type Props = {
  value: string;
  onChange: (value: string) => void;
  groups: LocationOptionGroup[];
  className?: string;
  required?: boolean;
  disabled?: boolean;
  placeholder?: string;
  /** Shown when value is not in groups (e.g. legacy row being edited). */
  orphanValue?: string | null;
};

export const LocationSelect: React.FC<Props> = ({
  value,
  onChange,
  groups,
  className = "eventos-select",
  required,
  disabled,
  placeholder = "Select location",
  orphanValue,
}) => {
  const allOptions = useMemo(() => groups.flatMap((group) => group.options), [groups]);
  const legacy = orphanValue?.trim() || value.trim();
  const showLegacy = Boolean(legacy) && !allOptions.includes(legacy);

  return (
    <MobileSelect
      label={placeholder}
      className={className}
      value={value}
      onChange={onChange}
      disabled={disabled}
      placeholder={placeholder}
      /* The sheet renders a flat list, so each group's heading is folded into
         its own labels rather than dropped. */
      options={[
        { value: "", label: placeholder },
        ...groups.flatMap((group) =>
          group.options.map((option) => ({ value: option, label: `${group.label} · ${option}` })),
        ),
        ...(showLegacy ? [{ value: legacy, label: `Other · ${legacy}` }] : []),
      ]}
    />
  );
};
